export default "/fr/_next/static/assets/images/lotto/swisslotto-logo.9986bbf8101e8bb72405ea79687c626a.png";